var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOpera = function SvgOpera(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.0496 18.7632C6.7224 17.196 5.8632 14.8824 5.8056 12.2832C5.8056 12.276 5.8056 11.724 5.8056 11.7168C5.8632 9.1176 6.7224 6.804 8.0496 5.2368C9.7728 3.0024 12.3312 1.584 15.1872 1.584C16.944 1.584 18.5904 2.1216 19.9968 3.0552C17.8848 1.164 15.1008 0.012 12.0456 0C12.0312 0 12.0144 0 12 0C5.3736 0 0 5.3736 0 12C0 18.4368 5.0664 23.688 11.4288 23.9856C11.6184 23.9952 11.808 24 12 24C15.072 24 17.8752 22.8456 19.9968 20.9472C18.5904 21.8784 16.9464 22.416 15.1872 22.416C12.3312 22.416 9.7728 20.9976 8.0496 18.7632Z",
    fill: "url(#opera_svg__paint0_linear_20_7680)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.0498 5.23678C9.1514 3.93598 10.5722 3.15358 12.1274 3.15358C15.6218 3.15358 18.4514 7.11358 18.4514 12C18.4514 16.8864 15.6194 20.8464 12.1274 20.8464C10.5746 20.8464 9.1514 20.0616 8.0498 18.7632C9.773 20.9976 12.3314 22.416 15.1874 22.416C16.9442 22.416 18.5906 21.8784 19.997 20.9472C22.4546 18.7488 24.0002 15.5544 24.0002 12C24.0002 8.44558 22.4546 5.25118 19.997 3.05518C18.5906 2.12158 16.9466 1.58398 15.1874 1.58398C12.3314 1.58398 9.773 3.00238 8.0498 5.23678Z",
    fill: "url(#opera_svg__paint1_linear_20_7680)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "opera_svg__paint0_linear_20_7680",
    x1: 9.99895,
    y1: 0.391296,
    x2: 9.99895,
    y2: 23.6507,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#FF1B2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4381,
    stopColor: "#FA1A2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5939,
    stopColor: "#ED1528"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7581,
    stopColor: "#D60E21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9272,
    stopColor: "#B70519"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A70014"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "opera_svg__paint1_linear_20_7680",
    x1: 16.0252,
    y1: 1.7622,
    x2: 16.0252,
    y2: 22.334,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9C0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#FF4B4B"
  })))));
};
export default SvgOpera;